import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/fieldReportTypes/findOrCreateGroup`;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReportTypes/findOrCreateGroup`;

export const URL = (): RouteDefinition =>
	`${baseRoute}/fieldReportTypes/findOrCreateGroup`;
